<template>
  <div id="loader" class="loader-wrapper">
    <div class="scanner">
      <div class="invoice"></div>
      <div class="scanner-bar"></div>
    </div>
    <div class="text">
      <p id="receiptPhrase1" class="desc_1">{{ $t(receiptPhrase1) }}</p>
      <p id="receiptPhrase2" class="desc_2">{{ $t(receiptPhrase2) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'receipt-scan-loader',
  props: {
    phrases: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      receiptPhrase1: this.phrases[0],
      receiptPhrase2: this.phrases[1],
      phraseElements: [],
      counter: 2,
      repeatPhraseFunction: function (event) {
        this[event.target.id] = this.phrases[this.counter]
        if (this.counter === this.phrases.length - 1) {
          this.counter = 0
        } else {
          this.counter++
        }
      }
    }
  },
  mounted () {
    this.phraseElements[0] = document.getElementById('receiptPhrase1');
    this.phraseElements[1] = document.getElementById('receiptPhrase2');
    if (this.phrases.length > 2) {
      this.phraseElements.forEach((element) => {
        element.addEventListener('webkitAnimationIteration', this.repeatPhraseFunction.bind(this));
        element.addEventListener('animationiteration', this.repeatPhraseFunction.bind(this));
      })
    }
  },
  onBeforeUnmount () {
    if (this.phrases.length > 2) {
      this.phraseElements.forEach((element) => {
        element.removeEventListener('webkitAnimationIteration', this.repeatPhraseFunction.bind(this));
        element.removeEventListener('animationiteration', this.repeatPhraseFunction.bind(this));
      })
    }
  }
}
</script>
